export var PricingType;
(function (PricingType) {
    PricingType["Fixed"] = "Fixed";
    PricingType["Scaled"] = "Scaled";
})(PricingType || (PricingType = {}));
